import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  padding: 10px;
  background-color: #f2f2f2;
  border: 1px solid #e4e4e4;
  overflow: auto;
`;

export const Inner = styled.div`
  display: flex;
  flex: 1;
  color: #fff;
  text-align: center;
  border: 1px solid #e4e4e4;

  dt {
    height: 30px;
    min-width: 30px;
    border-bottom: 1px solid #e4e4e4;
    font-size: 11px;
    line-height: 30px;
  }

  dd {
    height: 30px;
    min-width: 30px;
    line-height: 30px;
    font-size: 12px;
    background-color: #fff;
  }

  dl dd:last-child {
    border-top: 1px solid #f2f2f2;
  }

  .item {
    flex: 1;
    text-align: center;

    &.team {
      box-sizing: border-box;
      min-width: 90px;
      width: 90px;

      dt,
      dd {
        padding-left: 15px;
        text-align: left;
      }
    }

    &.score {
      font-size: 13px;
      font-weight: 300;

      dt,
      dd {
      }
    }
  }
`;
